/** The reseller actions that move an extraction from one status to another. */
export const ExtractionStatusAction = {
    DISCARD: 'DISCARD',
} as const;

export interface UpdateDocumentExtractionStatusInput {
    resellerId: string;
    extractionId: string;
    action: typeof ExtractionStatusAction[keyof typeof ExtractionStatusAction];
}
